import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInvestment = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 16,
	height: 16,
	viewBox: "0 0 16 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	color: "#515d71",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		x: 1.5,
		y: 2.429,
		width: 13,
		height: 11.143,
		rx: 1,
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M4.014 10.609L6.582 7.713C6.713 7.567 6.916 7.51 7.104 7.567L9.431 8.283C9.643 8.349 9.873 8.266 9.995 8.081L12.044 4.974",
		stroke: "currentColor",
		strokeLinecap: "round"
	})]
});
export default SvgInvestment;
